/**
 * Landing page — Test modu sade hali (S6+)
 *
 * Public signup kapalı, demo CTA'ları kaldırıldı.
 * Sadece logo + kısa tagline + Giriş Yap.
 * Authed kullanıcılar otomatik dashboard'a yönlenir.
 */
import { useEffect } from 'react';
import { Link, useLocation } from 'wouter';
import { useSession } from '../lib/auth-client.js';
import { api } from '../lib/api.js';

export function LandingPage(): JSX.Element | null {
  const { data: session, isPending } = useSession();
  const [, setLocation] = useLocation();
  const isAuthed = !!session?.user;

  useEffect(() => {
    if (isPending || !isAuthed) return;
    let cancelled = false;
    api
      .get<{ isBmuStaff?: boolean } | null>('/api/auth-extras/me')
      .then((me) => {
        if (cancelled) return;
        setLocation(me?.isBmuStaff ? '/admin/dashboard' : '/yonetici/dashboard');
      })
      .catch(() => {
        if (!cancelled) setLocation('/yonetici/dashboard');
      });
    return () => {
      cancelled = true;
    };
  }, [isPending, isAuthed, setLocation]);

  if (isPending || isAuthed) {
    return null;
  }

  return (
    <div className="flex min-h-screen flex-col bg-slate-50 text-slate-900">
      {/* Header */}
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-6 py-4">
          <div className="text-2xl font-bold tracking-tight">
            <span className="text-blue-900">BMU</span>
            <span className="text-sky-500">Works</span>
            <span className="ml-2 text-sm font-medium text-slate-500">
              SkillProbe
            </span>
          </div>
          <Link
            href="/yonetici/giris"
            className="rounded-lg bg-blue-900 px-4 py-2 text-sm font-medium text-white hover:bg-blue-800"
          >
            Giriş Yap
          </Link>
        </div>
      </header>

      {/* Hero */}
      <main className="flex flex-1 items-center justify-center px-6 py-16">
        <div className="max-w-2xl text-center">
          <h1 className="text-4xl font-bold tracking-tight sm:text-5xl">
            BMU SkillProbe
          </h1>
          <p className="mt-4 text-lg text-slate-600">
            AR-GE ekibinizin SolidWorks yetkinliğini ölçen kurumsal
            değerlendirme platformu.
          </p>
          <p className="mt-6 text-sm text-slate-500">
            Sistem şu anda test modundadır.
          </p>
          <Link
            href="/yonetici/giris"
            className="mt-8 inline-block rounded-lg bg-blue-900 px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-blue-800"
          >
            Giriş Yap
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-slate-200 bg-white">
        <div className="mx-auto max-w-5xl px-6 py-6 text-center text-xs text-slate-500">
          BMU Works © 2026 ·{' '}
          <a href="mailto:info@bmuworks.com" className="hover:text-blue-900">
            info@bmuworks.com
          </a>
        </div>
      </footer>
    </div>
  );
}
